import React from 'react';
import { motion } from 'framer-motion';
import { Flame, Heart, MessageCircle } from 'lucide-react';
export function ProtocolReveal() {
  const steps = [{
    icon: Flame,
    title: 'Re-encender',
    desc: 'Tu ambiente. Luz, aroma, un rincón que te reciba.'
  }, {
    icon: Heart,
    title: 'Re-ocupar',
    desc: 'Una micro-tarea con sentido. 7 minutos. Nada más.'
  }, {
    icon: MessageCircle,
    title: 'Re-conectar',
    desc: '1 contacto seguro. Un mensaje. Una voz.'
  }];
  return <section id="protocolo" className="py-24 md:py-32 px-4 bg-[#1a1714] relative overflow-hidden" data-id="element-56">
      {/* Ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#d4a574]/5 rounded-full blur-3xl pointer-events-none" data-id="element-57" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-58">
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-center text-[#d4a574] text-lg md:text-xl mb-6 font-serif italic" data-id="element-59">
          No necesitas ser social. Necesitas un ritual.
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="text-4xl md:text-6xl font-serif text-center text-[#f5efe6] mb-20" data-id="element-60">
          Protocolo 3R
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-61">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.3
        }} className="group p-8 rounded-xl bg-[#221e1b] border border-[#d4a574]/20 hover:border-[#d4a574]/40 transition-all duration-500 hover:shadow-[0_0_30px_-10px_rgba(212,165,116,0.15)]" data-id="element-62">
              <div className="w-12 h-12 rounded-full bg-[#d4a574]/10 flex items-center justify-center text-[#d4a574] mb-6 group-hover:scale-110 transition-transform duration-500" data-id="element-63">
                <step.icon size={24} strokeWidth={1.5} data-id="element-64" />
              </div>
              <h3 className="text-2xl font-serif text-[#f5efe6] mb-4" data-id="element-65">
                {step.title}
              </h3>
              <p className="text-[#a8a29e] leading-relaxed" data-id="element-66">{step.desc}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 1
      }} className="text-center text-[#f5efe6]/60 text-lg tracking-wide" data-id="element-67">
          20–30 minutos por noche. 10 noches. Sin forzarte.
        </motion.p>
      </div>
    </section>;
}